export default {
    purple: "#c3beff",
    breakpoints: {
        min: 400,
        mid: 900,
        max: 1200
    }
}